import { render, staticRenderFns } from "./ApprovalConfig.vue?vue&type=template&id=ca3b22dc"
import script from "./ApprovalConfig.vue?vue&type=script&lang=js"
export * from "./ApprovalConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports